// extracted by mini-css-extract-plugin
module.exports =  {"page":"vnCet4wJu97vbaGUrm4e"};